<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          
          <template v-for="(value, key, index) in account_changes_detail">

          <template v-for="field_array_column in  account_changes_detail['campaign_data_options']">


            <template v-for="field_array in field_array_column">


              <template v-if="field_array.identifier == 'company_name' && key == field_array['column_id']">
                

                <h3>Company Name - {{ value[0] }}</h3>

                


              </template>


              </template>
           
           </template>
           </template>



        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mt-10">
        <vs-col vs-type="flex" vs-w="12">
          <vs-row class="pb-4">
            <vs-col vs-w="4">
              <h6> Field </h6>
            </vs-col>
            <vs-col vs-w="4">
              <h6> Original Value </h6>
            </vs-col>
            <vs-col vs-w="4">
              <h6> Updated Value </h6>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

      <template v-for="(value, key, index) in account_changes_detail">
      <template v-if="key != 'campaign_data_options'">
        <vs-row vs-w="12">
          <vs-col vs-type="flex" vs-w="12">
            <vs-row class="pb-1">
              <vs-col vs-w="4" :class="{'add-background-color': value[0] != value[1]}">
                
                
                
                
                  


                     

                <template v-for="field_array_column in  account_changes_detail['campaign_data_options']">


                <template v-for="field_array in field_array_column">




                  <template v-if="field_array.column_id == key">
                    

              
                    {{ field_array.name }}


                  </template>


                  </template>
               
               </template>

                
                
              
              </vs-col>
              <vs-col vs-w="4" :class="{'add-background-color': value[0] != value[1]}">

                <div class="p-1" style="height:auto;">

                  <template v-if="value[0] != null && value[0] != '' && value[0] != '[]'">




                    <template v-for="field_array_column in  account_changes_detail['campaign_data_options']">


                      <template v-for="field_array in field_array_column">
      
      
                        <template v-if="field_array.column_id == key && field_array.identifier == 'phone'">
                          
      
                    
                          <template v-for="v in JSON.parse(value[0])">
                            {{ v['phone_no'] }} - {{ v['phone_type'] }}
                            <vs-divider class="mt-1" />
    
                          </template>
      
      
                        </template>


                        <template v-else-if="field_array.column_id == key && field_array.identifier == 'linkedin'">
                          
      
                    
                          <template v-for="v in JSON.parse(value[0])">
                            {{ v['url'] }}
                            <vs-divider class="mt-1" />
    
                          </template>
      
      
                        </template>


                        <template v-else-if="field_array.column_id == key && field_array.identifier == 'website'">
                          
      
                    
                          <template v-for="v in JSON.parse(value[0])">
                            {{ v['url'] }}
                            <vs-divider class="mt-1" />
    
                          </template>
      
      
                        </template>


                        <template v-else>

                          <template v-if="field_array.column_id == key">
                            <template v-if="typeof value[0] === 'string'">
      
      
                              <span v-if="value[0].startsWith('[') && value[0] != '[]'">
                                {{ JSON.parse(value[0]).toString() }}
      
                              </span>
      
                              <span v-else>

                                <template v-if="field_array.type == 'textarea'">
                                  <div v-html="value[0]"></div>
                                </template>
                                <template v-else>
                                  {{ value[0] }}
                                </template>




                              </span>
      
      
                            </template>
                            </template>
      
    
    
                        </template>
      
      
                        </template>
                     
                     </template>




                 

                  </template>


                  <template v-else>

                    EMPTY


                  </template>


                </div>
              </vs-col>
              <vs-col vs-w="4" :class="{'add-background-color': value[0] != value[1]}">

                <div class="p-1" style="height:auto;">

                  <template v-if="value[1] != null && value[1] != '' && value[1] != '[]'">

                    <template v-for="field_array_column in  account_changes_detail['campaign_data_options']">


                      <template v-for="field_array in field_array_column">
      
      
                        <template v-if="field_array.column_id == key && field_array.identifier == 'phone'">
                          
      
                    
                          <template v-for="v in JSON.parse(value[1])">
                            {{ v['phone_no'] }} - {{ v['phone_type'] }}
                            <vs-divider class="mt-1" />
    
                          </template>
      
      
                        </template>


                        <template v-else-if="field_array.column_id == key && field_array.identifier == 'linkedin'">
                          
      
                    
                          <template v-for="v in JSON.parse(value[1])">
                            {{ v['url'] }}
                            <vs-divider class="mt-1" />
    
                          </template>
      
      
                        </template>


                        <template v-else-if="field_array.column_id == key && field_array.identifier == 'website'">
                          
      
                    
                          <template v-for="v in JSON.parse(value[1])">
                            {{ v['url'] }}
                            <vs-divider class="mt-1" />
    
                          </template>
      
      
                        </template>


                        <template v-else>

                          <template v-if="field_array.column_id == key">
                            <template v-if="typeof value[1] === 'string'">
      
      
                              <span v-if="value[1].startsWith('[') && value[1] != '[]'">
                                {{ JSON.parse(value[1]).toString() }}
      
                              </span>
      
                              <span v-else>
                                <template v-if="field_array.type == 'textarea'">
                                  <div v-html="value[1]"></div>
                                </template>
                                <template v-else>
                                  {{ value[1] }}
                                </template>
      
                              </span>
      
      
                            </template>
                            </template>
      
    
    
                        </template>
      
      
                        </template>
                     
                     </template>


                  </template>


                  <template v-else>

                    EMPTY


                  </template>


                </div>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-divider />

        </template>

      </template>

    </vx-card>

    <vx-card class="mt-10" v-if="showContactSection">
   




      <template v-for="ccd in contact_changes_detail">
        

        <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          <!-- <h3>Contact Name - {{ ccd['forename'][0] }} {{ ccd['surname'][0] }} -->
          <!-- </h3> -->




            <template v-for="field_array_column in ccd['campaign_data_options']">
              
              
  
              <template v-for="field_array in field_array_column">
  
  
                <template v-if="field_array.identifier == 'forename'">
                  



                  <h3>Contact Name - {{ ccd[field_array['column_id']][0] }} {{ ccd['_755c8e1e_1725_4653_93f6_b8a888f4a423'][0] }} </h3>
  
                  
  
  
                </template>


              
  
  
                </template>
             
             </template>



        </vs-col>
      </vs-row>

      <h5 class="pointer" @click="showCallAttempts(ccd)"><u>Call Attempt : {{ccd['call_attempt'][0]}}</u> </h5>



      <vs-row vs-w="12" class="mt-10">
        <vs-col vs-type="flex" vs-w="12">
          <vs-row class="pb-4">
            <vs-col vs-w="4">
              <h6> Field </h6>
            </vs-col>
            <vs-col vs-w="4">
              <h6> Original Value </h6>
            </vs-col>
            <vs-col vs-w="4">
              <h6> Updated Value </h6>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>


        <template v-for="(value, key, index) in ccd">

          <template v-if="key != 'campaign_data_options'">
          

       

          <vs-row vs-w="12">
            <vs-col vs-type="flex" vs-w="12">
              <vs-row class="pb-1">
                <vs-col vs-w="4" :class="{'add-background-color': value[0] != value[1]}"
                  v-if="key != 'call_attempt' && key != 'account_id' && key != 'contact_id'">
                  <div class="p-1" style="height:auto;">



            <template v-for="field_array_column in ccd['campaign_data_options']">
              
              
  
              <template v-for="field_array in field_array_column">
  
  
                <template v-if="field_array['column_id'] == key">
                  


                  {{ field_array.name }}

  
                  
  
  
                </template>


              
  
  
                </template>
             
             </template>







                  </div>
                </vs-col>
                <vs-col vs-w="4" :class="{'add-background-color': value[0] != value[1]}"
                  v-if="key != 'call_attempt' && key != 'account_id' && key != 'contact_id'">

                  <div class="p-1" style="height:auto;">

                    <template v-if="value[0] != null && value[0] != ''">


                      <template v-for="field_array_column in ccd['campaign_data_options']">
              
              
  
                        <template v-for="field_array in field_array_column">
            
            
                          <template v-if="field_array['column_id'] == key && field_array['identifier'] == 'ddi'">


                              <template v-for="v in JSON.parse(value[0])">
                                {{ v['ddi_phone_code'] }} {{ v['ddi'] }} 
      
                                <vs-divider class="mt-1" />
      
                              </template>
      
                            
            
                          </template>


                          <template v-else-if="field_array['column_id'] == key && field_array['identifier'] == 'mobile'">


                            <template v-for="v in JSON.parse(value[0])">
                              {{ v['mobile_phone_code'] }} {{ v['mobile'] }} 
    
                              <vs-divider class="mt-1" />
    
                            </template>
    
                          
          
                        </template>

                        <template v-else-if="field_array['column_id'] == key && field_array['identifier'] == 'email'">


                          <template v-for="v in JSON.parse(value[0])">
                             {{ v['email'] }} 
  
                            <vs-divider class="mt-1" />
  
                          </template>
  
                        
        
                      </template>


                      <template v-else-if="field_array['column_id'] == key && field_array['identifier'] == 'contact_social_media'">


                        <template v-for="v in JSON.parse(value[0])">

                           {{ v['social_media'] }} 

                          <vs-divider class="mt-1" />

                        </template>

                      
      
                    </template>

                    <template v-else-if="field_array['column_id'] == key && field_array['identifier'] == 'grade'">



                         {{ value[0] }} 



                    
    
                  </template>


                    <template v-else>

                      <template v-if="field_array['column_id'] == key">



                      <template v-if="typeof value[0] === 'string'">


                        <span v-if="value[0].startsWith('[') && value[0] != '[]'">
                          {{ JSON.parse(value[0]).toString() }}

                        </span>

                        <span v-else>

                          <template v-if="field_array.type == 'textarea'">
                            <div v-html="value[0]"></div>
                          </template>
                          <template v-else>
                            {{ value[0] }}
                          </template>


                        </span>


                      </template>

                      </template>



                    </template>

                    
          
          
                        
            
            
                          </template>
                       
                       </template>


                


                     


                    </template>


                    <template v-else>

                      EMPTY


                    </template>


                  </div>
                </vs-col>
                <vs-col vs-w="4" :class="{'add-background-color': value[0] != value[1]}"
                  v-if="key != 'call_attempt' && key != 'account_id' && key != 'contact_id'">

                  <div class="p-1" style="height:auto;">

                    <template v-if="value[1] != null && value[1] != ''">



                      <template v-for="field_array_column in ccd['campaign_data_options']">
              
              
  
                        <template v-for="field_array in field_array_column">
            
            
                          <template v-if="field_array['column_id'] == key && field_array['identifier'] == 'ddi'">
                            


                              <template v-for="v in JSON.parse(value[1])">
                                {{ v['ddi_phone_code'] }} {{ v['ddi'] }} 
      
                                <vs-divider class="mt-1" />
      
                              </template>
      
                            
            
                          </template>


                          <template v-else-if="field_array['column_id'] == key && field_array['identifier'] == 'mobile'">


                            <template v-for="v in JSON.parse(value[1])">

                              
                              {{ v['mobile_phone_code'] }} {{ v['mobile'] }} 
    
                              <vs-divider class="mt-1" />
    
                            </template>
    
                          
          
                        </template>

                        <template v-else-if="field_array['column_id'] == key && field_array['identifier'] == 'email'">


                          <template v-for="v in JSON.parse(value[1])">
                             {{ v['email'] }} 
  
                            <vs-divider class="mt-1" />
  
                          </template>
  
                        
        
                      </template>


                      <template v-else-if="field_array['column_id'] == key && field_array['identifier'] == 'contact_social_media'">


                        <template v-for="v in JSON.parse(value[1])">


                           {{ v['social_media'] }} 

                          <vs-divider class="mt-1" />

                        </template>

                      
      
                    </template>


                    <template v-else>

                      <template v-if="field_array['column_id'] == key">



                      <template v-if="typeof value[1] === 'string'">


                        <span v-if="value[1].startsWith('[') && value[1] != '[]'">
                          {{ JSON.parse(value[1]).toString() }}

                        </span>

                        <span v-else>


                          <template v-if="field_array.type == 'textarea'">
                            <div v-html="value[1]"></div>
                          </template>
                          <template v-else>
                            {{ value[1] }}
                          </template>

                        </span>


                      </template>

                      <template v-else-if="field_array['column_id'] == key && field_array['identifier'] == 'grade'">



                        {{ value[1] }} 



                   
   
                 </template>


                      </template>



                    </template>

                    
          
          
                        
            
            
                          </template>
                       
                       </template>

                    </template>


                    <template v-else>

                      EMPTY


                    </template>


                  </div>
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
          <vs-divider v-if="key != 'call_attempt' && key != 'account_id' && key != 'contact_id'" />


          </template>
        </template>


      </template>

    </vx-card>

    <vs-popup title="Call Attempts" fullscreen :active.sync="showCallAttemptsPopup">

      <template lang="html">
        <div>

          <!-- <vs-row class="mt-5 mb-5" vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
            <vs-col vs-type="flex" vs-w="2">
              <h6>Contact Name - {{ contact_information['title'][0] }} {{ contact_information['forename'][0] }} {{
              contact_information['surname'][0] }}</h6>
            </vs-col>

            <vs-col vs-type="flex" vs-w="2">
              <h6>Job Title- {{ contact_information['job_title'][0] }}</h6>
            </vs-col>
          </vs-row> -->






          <vs-table ref="table_pagination" stripe max-items="10" pagination :data="contactsAuditTrials">

            <template slot="thead">
              <vs-th>Sales Developer</vs-th>
              <vs-th>Action Type</vs-th>
              <vs-th>OutCome</vs-th>
              <vs-th>Grade</vs-th>
              <vs-th>Notes</vs-th>
              <vs-th>Date/Time</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].sales_developer">
                  {{ data[indextr].sales_developer }}
                </vs-td>

                <vs-td :data="data[indextr].action_type">
                  {{ data[indextr].action_type }}
                </vs-td>

                <vs-td :data="data[indextr].outcome">
                  {{ data[indextr].outcome }}
                </vs-td>

                <vs-td :data="data[indextr].grade">
                  {{ data[indextr].grade }}
                </vs-td>
                <vs-td :data="data[indextr].notes">
                  {{ data[indextr].notes }}
                </vs-td>
                <vs-td :data="data[indextr].date_time">
                  {{ data[indextr].date_time }}
                </vs-td>



              </vs-tr>
            </template>
          </vs-table>
        </div>
      </template>

    </vs-popup>

  </div>
</template>

<script>
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleAuditTrialManagement from "@/store/audit-trial-management/moduleAuditTrialManagement.js";
import moment from "moment";
export default {
  data: () => ({
    contactsAuditTrials: [],
    phoneTypes: [],
    grade_options: [],
    checkedFields: [],
    user_id: null,
    abilities: null,
    selected_campaign: null,
    campaignDescription: [],
    account_changes_detail: null,
    contact_changes_detail: null,
    account_name: null,
    contact_name: null,
    showContactSection: false,
    contact_information: null,
    showCallAttemptsPopup: false

  }),
  components: {
  },
  watch: {},
  methods: {
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
    getCampaignReviewChangesAccountDetail() {
      let self = this
      let data = {}
      data.campaign_id = this.$route.params.campaignId
      data.account_id = this.$route.params.accountId
      data.campaign_name = atob(this.$route.params.campaignName)
      this.$store
        .dispatch("campaignsManagement/getCampaignReviewChangesAccountDetail", data)
        .then(res => {

          self.account_changes_detail = res.data;

          // if(self.account_changes_detail.hasOwnProperty('company_name')){
          //   self.account_name = self.account_changes_detail['company_name'][0]
          // }else{
          //   self.account_name = self.account_changes_detail['company'][0]
          // }

          for (const [key, value] of Object.entries(self.account_changes_detail)) {
            delete self.account_changes_detail['sales_developer_id'];
            delete self.account_changes_detail['campaign_id'];
            delete self.account_changes_detail['account_id'];
            delete self.account_changes_detail['tag_id'];
            delete self.account_changes_detail['id'];
            delete self.account_changes_detail['created_at'];
            delete self.account_changes_detail['default_factory'];
          }



        })
        .catch(err => {
          console.error(err);
        });
    },
    getCampaignReviewChangesContactDetail() {
      let self = this
      let data = {}
      data.campaign_id = this.$route.params.campaignId
      data.account_id = this.$route.params.accountId
      data.campaign_name = atob(this.$route.params.campaignName)
      this.$store
        .dispatch("campaignsManagement/getCampaignReviewChangesContactDetail", data)
        .then(res => {

          self.contact_changes_detail = res.data;

          self.showContactSection = true


          self.contact_changes_detail.forEach(element => {

              for (const [key, value] of Object.entries(element)) {
                delete element['sales_developer_id'];
                delete element['campaign_id'];
                delete element['tag_id'];
                delete element['id'];
                delete element['created_at'];
                delete element['default_factory'];
              }


          });


          console.log("contact detail" , self.contact_changes_detail)











        })
        .catch(err => {
          console.error(err);
        });
    },
    goBack: function () {
      this.$router.go(-1);

    },
    showCallAttempts(contact_information) {

      console.log("CON INF" , contact_information)

      let self = this
      let data = {}
      data.campaign_id = this.$route.params.campaignId
      data.contact_id = contact_information['contact_id'][0]
      data.account_id = contact_information['account_id'][0]
      self.$store
        .dispatch("AuditTrialsManagement/getAuditTrials", data)
        .then(res => {
          if (res) {

            self.contactsAuditTrials = res.data

            self.contactsAuditTrials.forEach(function (ele) {
              ele.date_time = moment(ele.date_time).format(
                "MM/DD/YYYY hh:mm:ss"
              );
            });


            self.showCallAttemptsPopup = true



             if (self.$refs.table_pagination.datax.length > 0) {
              self.$refs.table_pagination._data.currentx = 1
            }

            // self.$refs.table_pagination._data.currentx = 1



          }
        })
        .catch(err => {
          console.error(err);
        });

    }
  },
  beforeMount() {
  },
  mounted() {
    this.getCampaignDescription()
    this.getCampaignReviewChangesAccountDetail()
    this.getCampaignReviewChangesContactDetail()

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }


    if (!moduleAuditTrialManagement.isRegistered) {
      this.$store.registerModule(
        "AuditTrialsManagement",
        moduleAuditTrialManagement
      );
      moduleAuditTrialManagement.isRegistered = true;
    }



  }
};
</script>
<style scoped>
.social_media_radio {
  width: auto;
}

.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}


.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.accept-button {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}

.width_class {
  width: 580px;
}

.imput_field {
  width: 500px;
}



.dropdown_class {
  border: 1px solid transparent;
  margin: 4px 0 0 0;
  padding: 0 7px;
  background: none;
  box-shadow: none;
  width: 500px;
  background: none;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
  position: relative;
  font-family: inherit;
  height: 35px;
}

.add-background-color {
  background-color: rgb(245 239 239);
}

.ql-class {
  width: 580px;
}
</style>

<style lang="stylus">
.inputx
  margin-left 20px
  margin-top 10px



.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
